import React, { useEffect } from 'react'
import { injectIntl } from 'gatsby-plugin-intl-v6'
import Seo from './seo'
import { validLanguages } from '../utils/language'
import { navigate } from 'gatsby'

const getLanguageFromURL = () => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean)
  return validLanguages.includes(pathSegments[0]) ? pathSegments[0] : null
}

const getNavigateLang = () => {
  const browserLang = navigator.language || navigator.userLanguage // 检测浏览器语言
  console.log('navigator.language:', browserLang)
  const userLang = browserLang.split('-')[0] // 获取语言代码
  return validLanguages.includes(userLang) ? userLang : null
}

const Redirect = ({ intl }) => {
  useEffect(() => {
    // const defaultLanguage = 'en';

    // Step 1: 如果 URL 包含支持的语言前缀，不跳转，直接返回
    const currentLanguage = getLanguageFromURL()
    console.log('currentLanguage: ', currentLanguage)
    if (currentLanguage) {
      navigate(window.location.pathname) // 默认做次跳转，防止白屏
      return
    }
    // Step 2: 检查 localStorage 中的语言设置
    // localStorage.removeItem("gatsby-intl-language")
    const storedLanguage = localStorage.getItem('gatsby-intl-language')
    console.log('storedLanguage: ', storedLanguage)
    if (storedLanguage && validLanguages.includes(storedLanguage)) {
      return
    }
    // Step 3: 检查浏览器的语言设置
    const browserLanguage = getNavigateLang() // 获取浏览器语言的简写部分
    console.log('browserLanguage: ', browserLanguage)
    if (validLanguages.includes(browserLanguage)) {
      navigate(`/${browserLanguage}${window.location.pathname}`)
      console.log('navigate test')
      return
    }
    // Step 4: 如果以上条件都不满足，跳转到默认语言
    // navigate(`/${defaultLanguage}${window.location.pathname}`);
    // return
  }, [intl]) // 添加 intl 到依赖数组

  return <Seo title={`${intl.formatMessage({ id: 'title' })}`} description={''} meta={[]} lang={''} />
}

export default injectIntl(Redirect)
